import { addWeeks } from 'date-fns/addWeeks';

import { getZonedDate, ZonedDate } from '@eika-infrastruktur/date';
import { get } from '@eika-infrastruktur/request';
import { createQueryString } from '@eika-infrastruktur/utils';

import type { BankingDay } from '../generated-types';
import { CONTEXT_PATH } from './index';

const BANKINGDAYS_SERVICE_PATH = 'rest/resource/bankingdays';

const isBankinday = (day: BankingDay) => day.bankingDay;
const isNotBankinday = (day: BankingDay) => !day.bankingDay;

export const getNextSevenDays = (fromDate: ZonedDate): Promise<BankingDay[]> => {
    const queryString = createQueryString({
        fromDate: fromDate.toISOString(),
        toDate: addWeeks(fromDate, 1).toISOString(),
    });
    return get<BankingDay[]>(`${CONTEXT_PATH}/${BANKINGDAYS_SERVICE_PATH}${queryString}`);
};

export const getFirstBankingDay = async (fromDate: ZonedDate): Promise<ZonedDate | undefined> => {
    const bankingdays = await getNextSevenDays(fromDate);
    const hit = bankingdays?.find(isBankinday);
    if (hit) {
        return getZonedDate(hit.date);
    }
    return undefined;
};

export const getNextBankingDay = async (fromDate: ZonedDate): Promise<ZonedDate | undefined> => {
    const bankingdays = await getNextSevenDays(fromDate);
    const first = bankingdays?.findIndex(isBankinday);
    const daysAfterFirst = bankingdays?.slice(first + 1);
    const hit = daysAfterFirst.find(isBankinday);
    if (hit) {
        return getZonedDate(hit.date);
    }
    return undefined;
};

export const getBankingHolidays = async (fromDate: ZonedDate, toDate: ZonedDate): Promise<ZonedDate[]> => {
    const queryString = createQueryString({
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
    });
    const bankingDays = await get<BankingDay[]>(`${CONTEXT_PATH}/${BANKINGDAYS_SERVICE_PATH}${queryString}`);
    return bankingDays.filter(isNotBankinday).map((item) => getZonedDate(item.date));
};
